const substitute = (html, substitutions) => {
    if (html && substitutions) {
        let htmlCopy = `${html}`;
        for (let i = 0; i < substitutions.length; i++) {
            const regex = `<img([\\w\\W]+?)id="${substitutions[i].id}"([\\w\\W]+?)\\/?>`;
            const matchingTags = htmlCopy.matchAll(new RegExp(regex, "g"));
            for (const imgTag of matchingTags) {
                let imgTagStr = imgTag[0];
                imgTagStr = imgTagStr.replace(/src="\S*"/, `src="${substitutions[i].dataUrl}"`);
                htmlCopy = `${htmlCopy.substr(0, imgTag.index)}${imgTagStr}${htmlCopy.substr(imgTag.index + imgTag[0].length)}`;
            }
        }

        return htmlCopy
    }

    return html;
};

export default {
    substitute
};